import React from 'react';
import { StyledTable } from 'adapter/in/common/components/HomeTable/style';
import i18n from 'asset/translation';
import { Result, Heading } from '@dexma/ui-components';
import Bot from 'asset/images/bot.svg';
import { MarketAppView } from 'domain/entity/market/marketApp';

export type MarketAppTableProps = {
    columns: unknown | null;
    dataSource: MarketAppView[] | null;
    isLoading: boolean;
    showError: boolean;
};

const MarketAppTable = (props: MarketAppTableProps) => {
    const { columns, dataSource, isLoading, showError } = props;

    return (
        <>
            <Heading text={i18n.t('dashboards.marketAppsTitle')} />
            <StyledTable
                data-testid='apps-table'
                columns={columns}
                dataSource={dataSource}
                isLoading={isLoading}
                showError={showError}
                errorContent={
                    <Result
                        variant='default'
                        title={i18n.t('common.errorWrong')}
                        info={i18n.t('common.errorWrongInfo')}
                        iconElement={<Bot />}
                    />
                }
            />
        </>
    );
};

export default MarketAppTable;
